/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-intake
 * crm-screener-intake
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface QuestionOption
 */
export interface QuestionOption {
    /**
     * 
     */
    category?: string;
    /**
     * 
     */
    value: string;
}

/**
 * Check if a given object implements the QuestionOption interface.
 */
export function instanceOfQuestionOption(value: object): value is QuestionOption {
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function QuestionOptionFromJSON(json: any): QuestionOption {
    return QuestionOptionFromJSONTyped(json, false);
}

export function QuestionOptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuestionOption {
    if (json == null) {
        return json;
    }
    return {
        
        'category': json['category'] == null ? undefined : json['category'],
        'value': json['value'],
    };
}

export function QuestionOptionToJSON(json: any): QuestionOption {
    return QuestionOptionToJSONTyped(json, false);
}

export function QuestionOptionToJSONTyped(value?: QuestionOption | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'category': value['category'],
        'value': value['value'],
    };
}

